export default __webpack_public_path__ + "static/media/nft-lp-large.1cf724fa.png";